// 文節の頭になる語（漢字・カタカナ・英数字を含む）。ひらがなだけの語（助詞・活用語尾）と閉じ括弧・句読点は前の語に付ける
const CONTENT = /[\p{Script=Han}\p{Script=Katakana}ーA-Za-z0-9０-９Ａ-Ｚａ-ｚ]/u;
const OPEN = /^[「『（(［[【〈《“‘]+$/;
const SPACE = /^\s+$/;

/**
 * 見出しを、折り返してよいまとまり（文節に近い単位）に分ける。つなげると元の見出しに戻る。
 * 見出しは1文字ずつ箱に入れて動かすので、CSS の改行の指定（word-break: auto-phrase）が効かない。
 * まとまりごとに箱を作り、「始めましょ／う」のように語の途中で折れないようにする。
 */
export const titlePhrases = (title: string): string[] => {
  if (typeof Intl.Segmenter !== 'function') return Array.from(title);
  const out: string[] = [];
  let open = '';
  for (const segment of Array.from(new Intl.Segmenter('ja', { granularity: 'word' }).segment(title), (s) => s.segment)) {
    if (OPEN.test(segment)) {
      open += segment;
      continue;
    }
    const prev = out.length > 0 && !open ? out[out.length - 1] : '';
    const content = CONTENT.test(segment);
    // 名詞が続く間（料金＋プラン）と、助詞・語尾・閉じ括弧は前のまとまりに付ける
    const attach = prev !== '' && !SPACE.test(prev) && !SPACE.test(segment) && (!content || CONTENT.test(prev.slice(-1)));
    if (attach) out[out.length - 1] = prev + segment;
    else out.push(open + segment);
    open = '';
  }
  if (open) out.push(open);
  return out;
};
